<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">new user</small>
      </legend>
      <div>
        <form @submit.prevent="newUser()">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>fullnames</label>
                <input type="text" class="form-control fullnames" placeholder="fullnames" required />
              </div>
              <div class="form-group">
                <label>profile name</label>
                <input
                  type="text"
                  class="form-control profilename"
                  placeholder="profile name"
                  required
                />
              </div>

              <div class="form-group">
                <label>gender</label>
                <select name="gender" class="form-control gender" required>
                  <option value>select gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Email</label>
                <input type="email" class="form-control email" placeholder="email" required />
              </div>
              <div class="form-group">
                <label>password</label>
                <input
                  type="password"
                  id="password"
                  @keyup="checkPasswordStrength()"
                  class="form-control password"
                  placeholder="password"
                  required
                />
                <div id="password-strength-status"></div>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingUser" disabled>
            <i class="fa fa-user"></i> create user
          </button>
          <button type="button" class="btn btn-info btn-flat creatingUserLoader">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import $ from 'jquery'
export default {

  created() {
   
  },

  methods: {
    ...mapActions(["newUser", "checkPasswordStrength"])
  }
};
</script>
<style scoped>
.creatingUserLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/users/user.vue